<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                level: '100',
                status: 'pending',
                profile: {},
                functions: {
                    'shipping.shipper_maker': false,
                    'shipping.ecms': false,
                    'ecl.pokemon': false,
                    'ecl.yugioh': false,
                },
            }"
            :filters-default="{
                level: '',
                status: '',
                approval: '',
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'level',
                    title: '権限',
                    options: [
                        { text: '全て', value: '' },
                        { text: 'なし', value: '000' },
                        { text: 'デモ', value: '002' },
                        { text: '保険会社', value: '001' },
                        { text: '一般', value: '100' },
                        { text: '一般まとめ', value: '200' },
                        { text: '管理者', value: '300' },
                    ],
                },
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '準備', value: 'pending' },
                        { text: '稼働', value: 'activated' },
                        { text: '停止', value: 'suspended' },
                    ],
                },
                {
                    vModel: 'approval',
                    title: '承認待ち',
                    options: [
                        { text: '全て', value: '', },
                        { text: 'あり', value: '1', },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 名前', value: 'name', },
                        { text: '▼ 名前', value: '-name' },
                    ],
                },
            ]"
            filters-q-placeholder="#id,メール,会社名,代表者"
            form-modal-id="user"
            search-action="user/index"
            :hide-download="false"
            :row-clicked="auth_level >= 300"
            >
            <template v-slot:form="{ form, init }">
                <User :model="form" :init="init"></User>
            </template>

            <template>
                <b-col md="6"> 名前 </b-col>
                <b-col md="6"> メール </b-col>
            </template>

            <template v-slot:search-append="{ form, init }">
                <b-input-group-append
                    >
                    <b-button type="button" @click="onClickDownloadEbayOrdersSearch">
                        <font-awesome-icon icon="download" />
                        <small>注文</small>
                    </b-button>
                </b-input-group-append>
            </template>

            <template v-slot:column="{ item }">
                <b-col md="5" class="align-self-center">
                    <div class="d-flex mb-1">
                        <div>
                            <b-badge
                                :variant="$store.getters['user/level2variant'](item.level)"
                                >
                                {{
                                trans.labels[
                                'users.level.' + item.level
                                ]
                                }}
                            </b-badge>
                            <span>#{{ item.id }}</span>
                        </div>
                        <div class="ml-auto">
                            <small v-if="item.manager">
                                (まとめ親){{ item.manager.profile.saison_customer_number }}:{{ item.manager.profile.profile_company }}
                            </small>
                        </div>
                    </div>
    
                    <template v-if="item.profile">
                        {{ item.profile.profile_company }}<br>
                        セゾン顧客番号: {{ item.profile.saison_customer_number }}<br>
                    </template>

                    <template v-if="item.email">
                        <div>
                            <i class="far fa-fw fa-envelope"></i>
                            <b-link :href="'mailto:' + item.email">{{ item.email }}</b-link>
                        </div>
                    </template>
                </b-col>
    
                <b-col md="2" class="align-self-start">
                    <small>
                        機能<br>
                        <div
                            v-for="(val, key) in item.functions"
                            v-if="val"
                            >
                            {{ key }}
                        </div>
                    </small>
                </b-col>

                <b-col md="3" class="align-self-start">
                    <small v-if="item.profile">
                        <p class="mb-2">
                            <b>まるなげユーザーID:</b><br>
                            {{ item.profile.marunage_user_id }}
                        </p>
                        <template v-if="item.settings && item.settings.stores">
                            <p class="mb-2">
                                <b>eBay ID:</b><br>
                                <template v-if="item.settings.stores.ebay">
                                    {{ item.settings.stores.ebay.id }}
                                    <div v-if="item.settings.stores.ebay.eat" :class="{ 'text-danger': $moment().format('YYYY/MM/DD HH:mm:ss') >= $options.filters.BaseDatetimeFormatter(item.settings.stores.ebay.eat) }">{{ item.settings.stores.ebay.eat | baseDatetimeFormatter }}まで連携</div>
                                    <div v-if="item.settings.stores.ebay.eat"><a href="javascript:void(0)" @click="onClickDownloadEbayOrders(item)">注文DL</a></div>
                                </template>
                            </p>
                        </template>
                        <template v-if="item.settings && item.settings.inventories">
                            <p class="mb-2">
                                <b>Amazon ID:</b><br>
                                <template v-if="item.settings.inventories.amazon">
                                    {{ item.settings.inventories.amazon.id }}
                                    <div v-if="item.settings.inventories.amazon.eat" :class="{ 'text-danger': $moment().format('YYYY/MM/DD HH:mm:ss') >= $options.filters.BaseDatetimeFormatter(item.settings.inventories.amazon.eat) }">{{ item.settings.inventories.amazon.eat | baseDatetimeFormatter }}まで連携</div>
                                </template>
                            </p>
                        </template>
                    </small>
                </b-col>
    
                <b-col md="2" class="align-self-center">
                    <template v-if="item.approval && auth_level >= '300'">
                        <b-link :href="'/settings/users/' + item.uuid + '/approval'" target="_blank">承認待ち</b-link>
                    </template>
                </b-col>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import User from '@/components/User.vue'

export default {
    components: {
        GridPage,
        User,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_func',
            'auth_name',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
        async onClickDownloadEbayOrders (item) {
            this.$store
                .dispatch('user/download_orders', {
                    id: item.id,
                    provider: 'ebay',
                })
        },
        async onClickDownloadEbayOrdersSearch (event) {
            this.$utils.set(this.$refs.gridPage.grid.filters, { download_order_ebay: 1, })
            this.$refs.gridPage.download(event)
            this.$delete(this.$refs.gridPage.grid.filters, 'download_order_ebay')
        },
    },
}
</script>

